import { Typography } from "@suraasa/placebo-ui"

const SubscriptionCancelledBadge = ({ validTill }: { validTill: string }) => {
  return (
    <div className="flex flex-col items-start justify-between gap-2 rounded-lg bg-surface-100 p-2 sm:flex-row sm:items-center">
      <Typography
        variant="smallBody"
        className="max-w-[420px] text-onSurface-600"
      >
        Your Suraasa Plus subscription has been cancelled. You will still have
        access to all Plus features till{" "}
        <span className="text-strongSmallBody">{validTill}.</span>
      </Typography>
      {/* <Button
        color={null}
        className="shrink-0 rounded-[10px] border border-onSurface-300 bg-surface px-1.5 py-1 text-onSurface-700"
        onClick={handleClick}
      >
        Cancel Changes
      </Button> */}
    </div>
  )
}

export default SubscriptionCancelledBadge
